import PropTypes from 'prop-types'
import React from 'react'
import { translate } from 'react-i18next'
import styles2 from 'assets/scss/views/Auth2.scss'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { compose } from 'recompose'
import { Button } from '../components'
import * as routeService from '../services/routeService'
import * as translationService from '../services/translationService'
import AuthContent from './AuthContent'
import { WaitRender } from '../components/WaitRender/WaitRender'
import { resetPasswordRequest } from '../actions/AuthAction'

const mapStateToProps = state => {
  const { AuthReducer, FlowReducer } = state
  const { user = {}, error } = AuthReducer
  const { property } = FlowReducer
  const { email, id } = user

  return {
    email,
    id,
    property,
    error,
  }
}

const mapDispatchToProps = dispatch => ({
  resetPasswordRequest: mobileNumber => dispatch(resetPasswordRequest(mobileNumber)),
})

class ResetPasswordRequestedView extends React.PureComponent {
  static propTypes = {
    email: PropTypes.string,
    property: PropTypes.any,
    history: PropTypes.any,
    resetPasswordRequest: PropTypes.func,
  }

  resendSms = () => {
    routeService.goToForgotPasswordPage()
  }

  render() {
    const { email } = this.props

    return (
      <AuthContent
        title={translationService.passwordResetRequestLinkSentTitle()}
        subtitle={
          <div>
            {translationService.passwordResetLinkSentIntro()} <b>{email}</b>
          </div>
        }
        hasToken={false}>
        <div className={styles2.Spacer} />

        <WaitRender
          timeout={60000}
          withCountdown
          renderCountdown={secondsLeft => (
            <div>
              <Button disabled>{`${translationService.passwordResetPasswordRequestAgain()} (${secondsLeft})`}</Button>
            </div>
          )}>
          <div>
            <Button primary onClick={this.resendSms}>
              {translationService.passwordResetPasswordRequestAgain()}
            </Button>
          </div>
        </WaitRender>

        <div className={styles2.Spacer} />

        <div>
          <Link to={routeService.getPrefixPath() + '/login'}>{translationService.passwordResetSuccessToLogin()}</Link>
        </div>
      </AuthContent>
    )
  }
}

export default compose(
  translate('translations'),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(ResetPasswordRequestedView)



// WEBPACK FOOTER //
// ./src/views/ForgotPasswordLinkSentView.js